/**
 * 词典内容类型注册表（查词页 / 快速查词弹窗 / 设置页共用）
 * 中文展示名唯一来源：wordLookupSections.TAB_LABELS / SECTION_META.title
 */
import { SECTION_META, TAB_LABELS } from '@/views/englishLearning/wordLookup/wordLookupSections.js'

/** 设置页分组标题：与查词页大区块 title 一致（core 无外层大标题，不设组名） */
export const WORD_LOOKUP_SETTING_SECTION_TITLES = {
  extended: SECTION_META.extended.title,
  practice: SECTION_META.practice.title,
  network: SECTION_META.network.title,
}

export const WORD_LOOKUP_SETTING_SECTION_ORDER = ['core', 'extended', 'practice', 'network']

/** @typedef {{ id: string, label: string, section: 'core'|'extended'|'practice'|'network', defaultEnabled: boolean }} WordLookupContentTypeDef */

/** 默认排序：与查词页自上而下模块顺序一致 */
const TYPE_CATALOG = [
  { id: 'basic', section: 'core' },
  { id: 'cn_dict', section: 'core' },
  { id: 'inflections', section: 'core' },
  { id: 'web', section: 'extended' },
  { id: 'pro', section: 'extended' },
  { id: 'ee', section: 'extended' },
  { id: 'bilingual', section: 'practice' },
  { id: 'native', section: 'practice' },
  { id: 'authority', section: 'practice' },
  { id: 'phrase', section: 'network' },
  { id: 'syn', section: 'network' },
  { id: 'antonym', section: 'network' },
  { id: 'same', section: 'network' },
  { id: 'root', section: 'network' },
  { id: 'ety', section: 'network' },
]

/** @type {WordLookupContentTypeDef[]} */
export const WORD_LOOKUP_CONTENT_TYPE_DEFS = TYPE_CATALOG.map((item) => ({
  ...item,
  label: TAB_LABELS[item.id],
  defaultEnabled: true,
}))

/** 设置列表按查词页区块分组（组标题取自 SECTION_META） */
export function groupWordLookupContentItemsBySection (items = []) {
  return WORD_LOOKUP_SETTING_SECTION_ORDER
    .map((section) => ({
      section,
      title: WORD_LOOKUP_SETTING_SECTION_TITLES[section] || null,
      items: items.filter((item) => {
        const def = WORD_LOOKUP_CONTENT_TYPE_DEFS.find((d) => d.id === item.id)
        return def?.section === section
      }),
    }))
    .filter((group) => group.items.length)
}

export const WORD_LOOKUP_CONTENT_TYPE_IDS = WORD_LOOKUP_CONTENT_TYPE_DEFS.map((d) => d.id)

export const WORD_LOOKUP_CONTENT_TYPE_LABELS = Object.fromEntries(
  WORD_LOOKUP_CONTENT_TYPE_DEFS.map((d) => [d.id, d.label])
)

/** 游戏快速查词折叠摘要：从「已显示」顺序取前 N 条（有数据才展示） */
export const WORD_LOOKUP_QUICK_BRIEF_MAX = 3

/** 默认：全部类型已添加（与「全打开」一致） */
export function getDefaultWordLookupEnabledOrder () {
  return [...WORD_LOOKUP_CONTENT_TYPE_IDS]
}
